import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    failureDetailsContainer: {
        border: `3px solid ${theme.palette.error.light}`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        marginTop: theme.spacing(2),
    },
    failureDetailsButtonsContainer: {
        padding: `${theme.spacing(4)} ${theme.spacing(8)} 0 ${theme.spacing(8)}`,
        height: "100%",
    },
    failureButtonsContainer: {
        display: "flex",
        flexWrap: "wrap",
        columnGap: 15,
        rowGap: 12,
        justifyContent: "flex-start",
        alignContent: "flex-start",
        overflowY: "auto",
        height: "100%",
        flexBasis: 0,
        flexShrink: 1,
        flexGrow: 1,
    },
    buttonsBox: {
        display: "flex",
        flexDirection: "column",
        height: "90%",
    },
    failureDetailsButtonsMenu: {
        boxShadow: "0 -4px 4px -4px rgba(62, 93, 138, 0.2)",
        height: 70,
        padding: `${theme.spacing(3)} ${theme.spacing(8)}`,
        display: "flex",
        justifyContent: "space-between",
    },
    failureDetailsTitle: {
        color: theme.palette.text.primary,
        textAlign: "left",
        marginBottom: `${theme.spacing(4)} !important`,
    },
    goToHomeScreen: {
        boxShadow: "0 -4px 4px -4px rgba(62, 93, 138, 0.2)",
        height: 70,
        padding: `${theme.spacing(3)} ${theme.spacing(8)}`,
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    navigationButtonsContainer: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
    },
    splitMarker: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.info.main,
        borderRadius: 4,
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        marginBottom: theme.spacing(3),
    },
    splitMarkerText: {
        color: `${theme.palette.primary.main} !important`,
        fontWeight: 700,
        letterSpacing: "0.05em",
    },
}));
